<a [routerLink]="routerLinkStr">
  <div class="card grow"
       style="height: 150px"
       [ngStyle]="{
       'background-image': 'linear-gradient(to bottom, rgba(4, 60, 90, .7), rgba(4, 60, 90, .7)), url(' + backgroundImageStr + ')',
       'background-size': 'cover'
       }">
    <div class="card-body">
      <h5 class="card-title ">{{localeStr | translate}}</h5>
    </div>
  </div>
</a>
